var r = !0;
function o(i, e, n) {
  var s = "";
  return n.split(" ").forEach(function(t) {
    i[t] !== void 0 ? e.push(i[t] + ";") : s += t + " ";
  }), s;
}
var d = function(e, n, s) {
  var t = e.key + "-" + n.name;
  (s === !1 || r === !1) && e.registered[t] === void 0 && (e.registered[t] = n.styles);
}, u = function(e, n, s) {
  d(e, n, s);
  var t = e.key + "-" + n.name;
  if (e.inserted[n.name] === void 0) {
    var f = n;
    do
      e.insert(n === f ? "." + t : "", f, e.sheet, !0), f = f.next;
    while (f !== void 0);
  }
};
export {
  o as getRegisteredStyles,
  u as insertStyles,
  d as registerStyles
};
//# sourceMappingURL=emotion-utils.browser.esm.js.map
